import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import Logo from "../components/Logo";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const redirectTo = location.state?.from?.pathname || "/dashboard";

  useEffect(() => {
    if (user && typeof user === "object") {
      navigate(redirectTo, { replace: true });
    }
  }, [user, navigate, redirectTo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Welcome back.");
      navigate(redirectTo, { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="container-x py-16 lg:py-24" data-testid="login-page">
      <div className="max-w-md mx-auto card-soft p-8 lg:p-10">
        <Link to="/" className="inline-block mb-6" data-testid="login-logo">
          <Logo size={44} wordmarkClass="text-xl" />
        </Link>
        <h1 className="font-outfit text-3xl font-medium text-ink">Welcome back</h1>
        <p className="font-manrope text-sm text-ink-soft mt-2">
          Sign in to manage your registry or support someone you love.
        </p>

        <form onSubmit={handleSubmit} className="mt-8 space-y-4">
          <div>
            <label className="font-manrope text-sm text-ink mb-1 block" htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-soft"
              data-testid="login-email-input"
            />
          </div>
          <div>
            <label className="font-manrope text-sm text-ink mb-1 block" htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-soft"
              data-testid="login-password-input"
            />
          </div>
          {error && (
            <div className="tag-pill !bg-red-50 !text-red-700" data-testid="login-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="btn-primary w-full"
            data-testid="login-submit-btn"
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="mt-6 font-manrope text-sm text-ink-soft text-center">
          New here?{" "}
          <Link to="/register" className="text-brand font-medium hover:underline" data-testid="login-to-register-link">
            Create your account
          </Link>
        </p>
        <p className="mt-2 font-manrope text-sm text-ink-soft text-center">
          <Link to="/forgot-password" className="text-brand font-medium hover:underline" data-testid="login-forgot-link">
            Forgot your password?
          </Link>
        </p>
      </div>
    </div>
  );
}
